import React from "react";
import "./CityMission.css";
import elevenLogo from "../assets/images/eleven-group-logo.svg";

function CityMission() {
  const stats = [
    { value: "40+ years", label: "Around for", highlight: true },
    { value: "5", label: "Industries", highlight: false },
    { value: "40 Million+", label: "Customers till date", highlight: true },
  ];

  const sectors = [
    "Healthcare",
    "Financial services",
    "Consumer Technology",
    "Investment",
    "Energy",
  ];

  return (
    <section className="city-mission">
      <h2 className="city-mission-title">
        A city mission backed by institution building experience
      </h2>

      <div className="city-mission-stats">
        {stats.map((stat, index) => (
          <div key={index} className="city-mission-stat-card">
            <span className="city-mission-stat-value">
              {stat.value}
            </span>
            <span className="city-mission-stat-label">{stat.label}</span>
          </div>
        ))}
      </div>

      <div className="city-mission-eleven-card">
        <div className="city-mission-eleven-logo">
          <img src={elevenLogo} alt="Eleven" />
        </div>
        <p className="city-mission-eleven-text">
          We are a group building businesses for the real India. From healthcare to financing, insurance to technology; we create, scale, and support companies that touch everyday lives
        </p>
        <div className="city-mission-sectors">
          {sectors.map((sector, index) => (
            <span key={index} className="city-mission-sector-tag">
              {sector}
            </span>
          ))}
        </div>
      </div>

      <div className="city-mission-cta">
        <a
          href="https://elevengroup.in/"
          target="_blank"
          rel="noopener noreferrer"
          className="city-mission-btn"
        >
          View website
        </a>
      </div>
    </section>
  );
}

export default CityMission;
